document.addEventListener("DOMContentLoaded", () => {

    const sections = document.querySelectorAll(".fragrance-tabs-section");

    sections.forEach((section) => {

        const tabs = section.querySelectorAll(".fragrance-tab");
        const contents = section.querySelectorAll(".fragrance-content");
        const images = section.querySelectorAll(".fragrance-bg");

        tabs.forEach((tab) => {

            tab.addEventListener("click", () => {

                const id = tab.dataset.tab;

                // Remove Active Classes

                tabs.forEach(btn => btn.classList.remove("active"));
                contents.forEach(item => item.classList.remove("active"));
                images.forEach(item => item.classList.remove("active"));

                // Activate Selected

                tab.classList.add("active");
              const nav = tab.closest('.fragrance-nav');

nav.scrollTo({
    left: tab.offsetLeft - (nav.offsetWidth / 2) + (tab.offsetWidth / 2),
    behavior: 'smooth'
});

                const activeContent = section.querySelector(
                    `.fragrance-content[data-tab="${id}"]`
                );

                const activeImage = section.querySelector(
                    `.fragrance-bg[data-tab="${id}"]`
                );

                if (activeContent) {
                    activeContent.classList.add("active");
                }

                if (activeImage) {
                    activeImage.classList.add("active");
                }

            });

        });

    });

});